import routes, { resourcesType } from "@/helpers/router";

export const PageResourceCategory = {
  resources: "resources",
  ["resources-pregnancy"]: "pregnancy",
  ["resources-preconception"]: "preconception",
  ["resources-postpartum"]: "postpartum",
  ["resources-newborn-and-infant"]: "newborn-and-infant",
};

export const getCategory = (url) => {
  const urlArray = url?.split("/");

  return urlArray?.[urlArray?.length - 1];
};

export const getNavBarInfoForResourceListing: (navBarData: any, resource: resourcesType) => any = (
  navBarData,
  resource
) => {
  return navBarData?.map((data) => {
    const category = getCategory(data?.attributes?.Url);

    return {
      name: data?.attributes?.Name,
      category,
      slug: routes.resourcesListing(resource, category),
    };
  });
};
